module.exports = __webpack_public_path__ + "static/media/ic_agri.8c6e4945.png";